var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 30,
    viewBox: "0 0 35 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.735 27.574a.458.458 0 0 1-.329-.155L4.98 7.719a.432.432 0 0 1-.095-.337.466.466 0 0 1 .199-.302C5.8 6.631 7.58 5.19 7.304 3.885a.415.415 0 0 1 .198-.458.432.432 0 0 1 .5 0l21.764 18.335a.432.432 0 0 1-.552.656L8.132 4.688a5.562 5.562 0 0 1-2.185 2.841l16.124 19.328a.44.44 0 0 1-.051.614.45.45 0 0 1-.285.103z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M4.332 7.797a3.714 3.714 0 1 1 3.68-3.714 3.722 3.722 0 0 1-3.68 3.714zm0-6.564a2.85 2.85 0 1 0-.069 5.7 2.85 2.85 0 0 0 .07-5.7zM34.145 41.332H18.807a.423.423 0 0 1-.423-.518l3.55-16.643a4.68 4.68 0 0 1 9.154 0l3.454 16.625a.458.458 0 0 1-.086.363.458.458 0 0 1-.311.173zm-14.811-.864H33.61L30.24 24.37a3.817 3.817 0 0 0-7.47 0l-3.437 16.098z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M26.476 28.87a3.023 3.023 0 1 1-.017-6.046 3.023 3.023 0 0 1 .017 6.046zm0-5.182a2.16 2.16 0 1 0 2.15 2.15 2.15 2.15 0 0 0-2.15-2.15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.546 13.592a.432.432 0 0 1-.431-.432V7.28a.432.432 0 0 1 .863 0v5.89a.44.44 0 0 1-.432.423z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.538 19.81a3.54 3.54 0 0 1-3.3-2.168.423.423 0 0 1 .234-.561c.217-.09.466.01.561.225a2.677 2.677 0 1 0 2.47-3.714.432.432 0 0 1 0-.864 3.54 3.54 0 0 1 0 7.082h.035z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrane);
export default __webpack_public_path__ + "static/media/crane.f0d3a9a88258dde828132612dca95134.svg";
export { ForwardRef as ReactComponent };